import Repository from '@/api/Repository'

const resource = '/bulk-download'
const DOWNLOAD_LINK_PATH = 'get-download-link'

export default {
  list() {
    return Repository.get(`${resource}/list`)
  },

  add(ids, fatherId) {
    return Repository.post(`${resource}/add`, {
      objects_id: ids,
      father_id: fatherId,
    })
  },

  cancel(downloadId) {
    return Repository.post(`${resource}/${downloadId}/cancel`)
  },

  getLink(downloadId) {
    return Repository.get(`${resource}/${DOWNLOAD_LINK_PATH}/${downloadId}`)
  },
}
